<template>
  <div class="box" :class="position">

  </div>
</template>

<script>
export default {
  name: "WhiteBackground",
  props: {
    half: {type: String, default: 'false'}
  },
  data() {
    return {
      position: 'full'
    }
  },
  mounted() {
    if (this.half === 'true') {
      this.position = 'half'
    }
  }
}
</script>

<style scoped>
  .box{
    position: absolute;
    background-color: rgba(255, 255, 255, 0.9);
    height: 100%;
    z-index: -99;
  }
  .full{
    margin: 0 10% 0 10%;
    width: 80%;
    //height: calc(100% - clamp(0.75rem, 2vw, 1.25rem));
    height: 100%
  }
  .half{
    margin: 0 10% 0 25%;
    width: 70%;
    //height: calc(100% - clamp(0.75rem, 2vw, 1.25rem));
    height: 100%
  }
</style>
